import React from 'react';

import Dropdown, { IDropdownProps } from '@/components/common/Dropdown/Dropdown';
import TopLabel from '@/components/common/TopLabel/TopLabel';
import ValidationAlert from '@/components/common/ValidationAlert/ValidationAlert';

import { IModalFormProps } from '../ModalFormProps.interface';


interface IModalFormDropdownProps<OptionType> extends IModalFormProps, IDropdownProps<OptionType> {
  id: string;
}

export default function ModalFormDropdown<OptionType>({
  id,
  className,
  labelTitle,
  requiredIcon = false,
  validationMessage,
  isFloatingValidation = false,
  ...restProps
}: IModalFormDropdownProps<OptionType>) {
  return (
    <div className={className}>
      {labelTitle && (
        <TopLabel
          id={id}
          label={labelTitle}
          required={requiredIcon}
        />
      )}

      <Dropdown<OptionType> {...restProps} />

      {validationMessage && (
        <ValidationAlert
          isFloating={isFloatingValidation}
          type="danger"
        >
          {validationMessage}
        </ValidationAlert>
      )}
    </div>
  );
}
